/* APP DATA */
export const GET_APPLICATIONS = "GET_APPLICATIONS";
export const SET_APPLICATIONS = "SET_APPLICATIONS";
export const PATCH_APPLICATION = "PATCH_APPLICATION";

/* FOR 1 APP */
export const GET_APP = "GET_APP";
export const SET_APP = "SET_APP";
export const GET_CLIENT_APPS = "GET_CLIENT_APPS";
export const DELETE_APP = "DELETE_APP";
export const SET_CLIENT_APPS = "SET_CLIENT_APPS";
export const SET_APP_CLEAR = "SET_APP_CLEAR";
export const ADD_APP = "ADD_APP";
export const GET_APP_DATA = "GET_APP_DATA";
export const SET_APP_DATA = "SET_APP_DATA";
export const SET_APP_DATA_NULL = "SET_APP_DATA_CLEAN";
export const PATCH_APPLICATION_STATUS = "PATCH_APPLICATION_STATUS";

/* SHOW APP LOADING */
export const SHOW_APP_LOADER = "SHOW_APP_LOADER";
export const HIDE_APP_LOADER = "HIDE_APP_LOADER";
